<div class="td-cnt-ext">
    <div class="td-cnt">
        <app-itdcr style="width: 100%;" [inputItdcrNo]="itdcrNo" [inputShowHistory]="showHistory" [inputEmbeddedMode]="true"
            (onBackClick)="onCloseModal()"></app-itdcr>
    </div>
</div>
